import React, { useEffect } from 'react';
import { Button } from '@/ui/components/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './DerogationDeclarationPage.module.scss';
import { Icon } from '@/ui/icons/Icon';
import { pageFacingUp } from '@/assets/images/emojis';
import { useKyc } from '@/features/kyc/hooks/useKyc';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { format } from 'date-fns';
import { routes } from '@/routes';

export const DerogationDeclarationPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getUserIdentityCard, identityCard, isIdentityCardLoading } = useKyc();

  const returnTo =
    (location.state as { returnTo?: string } | null)?.returnTo ??
    routes.application.installmentConfirmation;

  useEffect(() => {
    getUserIdentityCard();
  }, []);

  const handleAccept = () => {
    // The final offer's changes, when opened from the chosen preliminary credit.
    navigate(returnTo, { state: location.state });
  };

  if (isIdentityCardLoading) {
    return <PageLoader />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.scrollable}>
        <div className={styles.header}>
          <div className={styles.emojiContainer}>
            <img
              src={pageFacingUp}
              alt="Page facing up"
              className={styles.emoji}
            />
          </div>
          <div className={styles.headerText}>
            <h1 className={styles.title}>Declarație pe propria răspundere</h1>
            <p className={styles.subtitle}>
              Te rugăm să citești și să accepți declarația pentru a continua
            </p>
          </div>
        </div>

        <div className={styles.document}>
          <div className={styles.termsBox}>
            <p>
              Dl/Dna. {identityCard?.firstName} {identityCard?.lastName},
              identificat/ă cu CNP {identityCard?.cnp} și CI cu seria{' '}
              {identityCard?.serialCode} nr. {identityCard?.serialNumber},
              valabil până la data de{' '}
              {identityCard?.expireDate
                ? format(identityCard?.expireDate, 'dd.MM.yyyy')
                : ''}
              , în calitate de solicitant de credit,
            </p>
            <p>
              Formulez prezenta declarație pentru a confirma că acest credit îmi
              este necesar pentru acoperirea unor nevoi personale. Accept în mod
              expres și îmi asum contractarea acestui credit chiar și în ipoteza
              depășirii gradului maxim de îndatorare de 40%.
            </p>
            <p>
              Față de cele de mai sus, raportat la gradul meu total de
              îndatorare, confirm și declar expres si neechivoc că am mijloacele
              și resursele necesare achitării obligațiilor lunare de plată
              aferente creditului.
            </p>
            <p>
              Subsemnatul/a, având cunoștință de prevederile Codului Penal
              privind Falsul în declarații, declar că toate datele și
              informațiile completate în prezentul document sunt corespunzătoare
              adevărului și în caz contrar îmi asum toate consecințele de natură
              penală, administrativă și civilă, prevăzute de lege.
            </p>
            <p>
              Astfel, declar că toate informațiile furnizate prin intermediul
              acestei declarații, sunt adevărate și corecte, prezenta servind la
              întocmirea dosarului pentru obținerea creditului.
            </p>
            <p>
              Mă oblig ca, în urma aprobării împrumutului de către OCEAN CREDIT
              IFN SA, în termen de 30 de zile de la data acordării împrumutului,
              să pun la dispoziția OCEAN CREDIT IFN SA, documente justificative
              care să susțină cererea mea și să justifice destinația creditului.
              Aceste documente vor fi transmise în format fizic sau electronic.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Button
          trackingId="accept_derogation_declaration"
          variant="filled"
          text="Accept"
          className={styles.button}
          onClick={handleAccept}
          leftIcon={<Icon name="check" />}
        />
      </div>
    </div>
  );
};
